import type { ReactNode } from 'react';

/** Error that belongs to no field (network failure, rejected link); `role="alert"` announces it. */
export function FormAlert({ children }: { children?: ReactNode }) {
  if (!children) return null;

  return (
    <p role="alert" className="dlz-body-s w-full whitespace-pre-line text-center text-[#D7191F]">
      {children}
    </p>
  );
}
